
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xlim-support",
      function () {
        return require("private-next-pages/xlim-support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/xlim-support"])
      });
    }
  